export { default as WaveSurferContainer } from './WaveSurferContainer';
export { default as Minimap } from './Minimap';
export { default as ClipRegion } from './ClipRegion';
export * from './types';
export { default } from './WaveSurfer';
